<template>
    <div
        v-if="markersFilled"
        class="content"
    >
        <p>{{ infotext }}</p>
        <br>
        <p class="content-text-info">
            {{ $t("App.Posti.KartallaNakyvatToimipaikat") }}
        </p>
        <br>
        <dynamic-table
            v-if="layersVisible"
            :table-data="markerData"
            :show-footer="false"
            :show-footer-legend="false"
            :show-dot-column="false"
            @row-clicked="tableRowClicked"
        />
        <br>
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-facing-decorator"
    import DynamicTable from "@/components/DynamicTableResponsive.vue"
    import TableData from "@/models/tabledata"
    import DynamicModalData from "@/models/dynamicmodaldata"
    import ApiService from "@/services/ApiService"
    import PostiService from "@/services/PostiService"
    import DynamicRightSlotData from "@/models/dynamicrighslotdata"
    import SearchResultModel from "@/models/searchresultmodel"
    import { store } from '@/store/store'

    @Component({
        components: {
            "dynamic-table": DynamicTable
        }
    })
    export default class PostiHaeToimipaikkoja extends Vue {
        apiService: ApiService = new ApiService(store.getters.baseHref)
        postiService: PostiService = new PostiService()

        /** Haetaan palvelupisteiden m��r�t storesta ja n�ytet��n ne taulukossa. M��r�t lasketaan kartan piirron yhteydess�.(Map.vue / countVisibleMarkers) */
        get markerData() {
            const markers = store.getters.visibleMarkers as Map<string, number> | null
            const tableValues: Map<string[], boolean> = new Map()
            tableValues.set([this.$t("App.Posti.Postitoimipisteet") ?? "", markers?.get("postitoimipiste")?.toString() ?? "0"], false)
            tableValues.set([this.$t("App.Posti.Noutopisteet") ?? "", markers?.get("noutopiste")?.toString() ?? "0"], false)
            tableValues.set([this.$t("App.Posti.Postilokerot") ?? "", markers?.get("postilokero")?.toString() ?? "0"], false)
            tableValues.set([this.$t("App.Posti.Pakettiautomaatit") ?? "", markers?.get("pakettiautomaatti")?.toString() ?? "0"], false)
            tableValues.set([this.$t("App.Posti.Kirjelaatikot") ?? "", markers?.get("kirjelaatikko")?.toString() ?? "0"], false)
            tableValues.set([this.$t("App.Posti.Yrityspisteet") ?? "", markers?.get("yrityspiste")?.toString() ?? "0"], false)

            return new TableData(this.tableColumHeaders, null, tableValues)
        }

        get tableColumHeaders(): string[] {
            const columns: string[] = []
            columns.push(this.$t("App.Posti.Palvelupiste") ?? "App.Posti.Palvelupiste")
            columns.push(this.$t("App.Posti.Maara") ?? "App.Posti.Maara")
            return columns
        }

        get slotData(): DynamicRightSlotData | null {
            return store.getters.rightSlotData as DynamicRightSlotData
        }

        get layersVisible(): boolean {
            return store.getters.layersVisible
        }

        get markersFilled() {
            return store.getters.visibleMarkers !== null
        }

        get infotext(): string | undefined {
            if (this.searchAddressSelected !== null) {
                return this.$t("App.Posti.Toimipaikat.RightSlot.InfoText") + " " + this.searchAddressSelected.getFullName() + "."
            }
        }

        get searchAddressSelected(): SearchResultModel | null {
            return store.getters.searchAddressSelected
        }

        async tableRowClicked(row: number) {
            let type = ""
            let header = ""

            // haetaan näkyvien markkeireiden datat
            const markersData = store.getters.markersData as Map<string, string> | null
            const markers = store.getters.visibleMarkers as Map<string, number> | null

            // haetaan vain valitun rivin/tyyppin datat /luotetaan tässä kohtaa rivin numerointiin ja järjestykseen
            if (row === 0) {
                type = "postitoimipiste"
                header = this.$t("App.Posti.Postitoimipisteet") ?? ""
            }
            else if (row === 1) {
                type = "noutopiste"
                header = this.$t("App.Posti.Noutopisteet") ?? ""
            }
            else if (row === 2) {
                type = "postilokero"
                header = this.$t("App.Posti.Postilokerot") ?? ""
            }
            else if (row === 3) {
                type = "pakettiautomaatti"
                header = this.$t("App.Posti.Pakettiautomaatit") ?? ""
            }
            else if (row === 4) {
                type = "kirjelaatikko"
                header = this.$t("App.Posti.Kirjelaatikot") ?? ""
            }
            else {
                type = "yrityspiste"
                header = this.$t("App.Posti.Yrityspisteet") ?? ""
            }
            let textContent = ""
            // avataan modaali tarkempien tietojen näyttämiseksi
            try {
                const count = markers?.get(type) ?? null
                if (count == null || count === 0) return // ei ole mitään näytettävää

                store.dispatch("setLoading", { name: "postiHaeToimipaikkoja", value: true })

                const ids = markersData?.get(type)?.split(",").filter(Boolean) ?? null
                const dataTypes = this.postiService.getDataTyyppi(type)

                const data = await this.apiService.getPopupDetailsPostiTyyppi(dataTypes, ids)
                textContent += await this.postiService.createPopuptext(data)
                store.dispatch("setLoading", { name: "postiHaeToimipaikkoja", value: false })

                const modalData = new DynamicModalData(type, header, textContent, count)
                store.dispatch("setModalData", modalData)
                this.openModal()
            }
            catch (err) {
                store.dispatch("setLoading", { name: "postiHaeToimipaikkoja", value: false })
                throw new Error(this.apiService.generateErrorMsg(err))
            }
        }

        openModal() {
            store.dispatch("setModalComponentName", "PostitoimipisteetModal")
        }
    }
</script>
